var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.schema.settings.backgroundColor }, [
    _c(
      "div",
      {
        staticClass: "ff__container",
        style: { "max-width": _vm.schema.settings.maxWidth }
      },
      [
        _c(
          "split-wrapper",
          {
            attrs: {
              imageWidthClass: _vm.schema.settings.imageWidth,
              backgroundColorClass: _vm.schema.settings.backgroundColor,
              textAlignmentClass: _vm.schema.settings.textAlignment,
              reversedClass: _vm.schema.settings.layout,
              marginTop: _vm.schema.settings.marginTop,
              marginBottom: _vm.schema.settings.marginBottom
            }
          },
          [
            _c("template", { slot: "image" }, [
              _c(
                "a",
                {
                  staticClass: "ff__image ff__image",
                  attrs: {
                    href: _vm.schema.settings.ctaUrl,
                    "aria-label":
                      _vm.schema.settings.subheader ||
                      _vm.schema.settings.preheader
                  }
                },
                [
                  _c("picture", [
                    _c("source", {
                      attrs: {
                        srcset: _vm.imageSize(
                          _vm.schema.settings.imageDesktop,
                          "900x"
                        ),
                        media: "(min-width: 992px)"
                      }
                    }),
                    _c("source", {
                      attrs: {
                        srcset: _vm.imageSize(
                          _vm.schema.settings.imageMobile ||
                            _vm.schema.settings.imageDesktop,
                          "900x"
                        ),
                        media: "(min-width: 768px)"
                      }
                    }),
                    _c("img", {
                      attrs: {
                        src: _vm.imageSize(
                          _vm.schema.settings.imageMobile ||
                            _vm.schema.settings.imageDesktop,
                          "600x"
                        ),
                        alt:
                          _vm.schema.settings.subheader ||
                          _vm.schema.settings.preheader,
                        loading: "lazy"
                      }
                    })
                  ])
                ]
              )
            ]),
            _c("template", { slot: "content" }, [
              _c(
                "div",
                { staticClass: "ff__main-wrap" },
                [
                  _vm.schema.settings.preheader
                    ? _c(
                        "p",
                        {
                          staticClass: "preheader ff__preheader",
                          class: _vm.schema.settings.preheaderColor
                        },
                        [_vm._v(_vm._s(_vm.schema.settings.preheader))]
                      )
                    : _vm._e(),
                  _vm.schema.settings.header
                    ? _c(
                        "h2",
                        {
                          staticClass: "ff__header",
                          class: [
                            _vm.schema.settings.imageWidth === "sw--50"
                              ? "h3"
                              : "h2",
                            _vm.schema.settings.headerColor
                          ]
                        },
                        [_vm._v(_vm._s(_vm.schema.settings.header))]
                      )
                    : _vm._e(),
                  _vm.schema.settings.subheader
                    ? _c(
                        "p",
                        {
                          staticClass: "subheader ff__subheader",
                          class: _vm.schema.settings.subheaderColor
                        },
                        [_vm._v(_vm._s(_vm.schema.settings.subheader))]
                      )
                    : _vm._e(),
                  _vm.schema.settings.body
                    ? _c("div", {
                        staticClass: "ff__body",
                        class:
                          ((_obj = {}),
                          (_obj[_vm.schema.settings.bodyColor] = true),
                          (_obj["ff-body-margin-bottom--none"] = !(
                            _vm.schema.settings.ctaText &&
                            _vm.schema.settings.ctaUrl
                          )),
                          _obj),
                        domProps: {
                          innerHTML: _vm._s(_vm.schema.settings.body)
                        }
                      })
                    : _vm._e(),
                  _vm.schema.settings.ctaText && _vm.schema.settings.ctaUrl
                    ? _c(
                        /link/.test(_vm.schema.settings.ctaStyle)
                          ? "v-link"
                          : "v-button",
                        {
                          tag: "component",
                          class: _vm.schema.settings.ctaStyle,
                          attrs: { tag: "a", href: _vm.schema.settings.ctaUrl }
                        },
                        [_vm._v(_vm._s(_vm.schema.settings.ctaText))]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }